import { WaffleFlag } from "@alch/dx-entities";
import { trpc } from "@util/trpc/trpcClient";

export function useIsWaffleFlagEnabled(flagName: WaffleFlag) {
  return trpc.waffle.isFlagEnabled.useQuery(
    { flagName },
    { staleTime: 60 * 1000 },
  );
}
